import axios from "axios";
import { Payout_Service } from "../Url";

export const PayoutPartnerDataAction = {
  PAYOUT_PARTNER_DATA_SUCCESS: "PAYOUT_PARTNER_DATA_SUCCESS",
  PAYOUT_PARTNER_DATA_ERROR: "PAYOUT_PARTNER_DATA_ERROR",
  PAYOUT_PARTNER_DATA_REMARKS_SUCCESS: "PAYOUT_PARTNER_DATA_REMARKS_SUCCESS",
  PAYOUT_PARTNER_DATA_REMARKS_ERROR: "PAYOUT_PARTNER_DATA_REMARKS_ERROR",
  PAYOUT_MONTHLY_SUMMARY_SUCCESS:"PAYOUT_MONTHLY_SUMMARY_SUCCESS",
  PAYOUT_MONTHLY_SUMMARY_ERROR:"PAYOUT_MONTHLY_SUMMARY_ERROR",
};


export function payoutPartnerDataSuccess(props) {
  const { accessToken, financialYear, page, record, reportId, approvalStageId } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: `${process.env.REACT_APP_PAYOUT_SERVICE}/partner-payout-service/reports/get/partner?report_id=${reportId}&page=${page}&size=${record}&approval_stage_id=${approvalStageId}`,
        // url: `http://localhost:8301/partner-payout-service/reports/get/partner?report_id=${reportId}&page=${page}&size=${record}&approval_stage_id=${approvalStageId}`,
        url: `${Payout_Service}/reports/get/partner?report_id=${reportId}&page=${page}&size=${record}&approval_stage_id=${approvalStageId}`,
        data: {
          financialYear,
          page,
          record,
        },
      });
      const data = response.data;
      dispatch({
        type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_SUCCESS,
        payload: data.data,
      });
      console.log("Payout Partner Data:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_ERROR,
        payload: error.message || "Failed to fetch payout partner data",
      });
      return error;
    }
  };
}



export function getPayoutRemarksSuccess(props) {
  const { accessToken, reportId, partnerId } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "Post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/get/remarks?partnerId=${partnerId}&reportId=${reportId}`,
        // url: `http://localhost:8301/partner-payout-service/reports/get/remarks?partnerId=${partnerId}&reportId=${reportId}`,
      });
      const data = response.data;
      dispatch({
        type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_REMARKS_SUCCESS,
        payload: data.data,
      });
      console.log("Payout Partner Remarks:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_REMARKS_ERROR,
        payload: error.message || "Failed to fetch payout partner remarks",
      });
      return error;
    }
  };
}

export function addPayoutRemarksSuccess(props) {
  const { accessToken, remarks } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "Post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/add/remarks`,
        // url: `http://localhost:8301/partner-payout-service/reports/add/remarks`,
        data: remarks,
      });
      const data = response.data;
      // dispatch({
      //   type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_REMARKS_SUCCESS,
      //   payload: data.data,
      // });
      console.log("Payout Partner Remarks Added:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      // dispatch({
      //   type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_REMARKS_ERROR,
      //   payload: error.message || "Failed to add payout partner remarks",
      // });
      return error;
    }
  };
}

export function getMonthlySummarySuccess(props){
  const {accessToken, reportId} = props;
  return async (dispatch) => {
    try{
      const response = await axios({
        method: "Post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: `http://localhost:8301/partner-payout-service/reports/get/monthly/summary?report_id=${reportId}`,
        url:`${Payout_Service}/reports/get/monthly/summary?report_id=${reportId}`,
        data: {
          reportId
        }
      });
      const data = response.data;
      dispatch({
        type: PayoutPartnerDataAction.PAYOUT_MONTHLY_SUMMARY_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: PayoutPartnerDataAction.PAYOUT_PARTNER_DATA_ERROR,
        payload: error.message || "Failed to fetch payout partner data",
      });
      return error;
    }
  }
}

export function payoutPartnerDataSearch(props) {
  const { accessToken, reportId,approvalStageId, partner_name } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",

        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/search/partner?report_id=${reportId}&approval_stage_id=${approvalStageId}&search_query_partner_name=${partner_name}&search_query_partner_disp_code=`,  
      });
      const data = response.data;
      
      console.log("Payout Partner Data Search:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
    
      return error;
    }
  }
}